import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProductionDeviceAddPageComponent } from './production-device-add-page.component';

const routes: Routes = [
  {
    path: 'production-device-add-page',
    data: { name: 'Production - Device', isTab: false },
    component: ProductionDeviceAddPageComponent,
  },
  {
    path: 'production-device-add-page/:id',
    component: ProductionDeviceAddPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductionDeviceAddPageRoutingModule {}
